export default "__VITE_ASSET__DcDq96UN__"